import { string } from '@iwentsourcing/core/typing/string.js';
import { TypeOfEvent } from '@iwentsourcing/core/typing/type-of.js';
import { declareEvent } from '@iwentsourcing/core/storage/declare-event.js';

export const EmailSendEventV2 = declareEvent('email.send.v2', {
  to: string(),
  subject: string(),
  cc: string(),
});
export type EmailSendEventV2 = TypeOfEvent<typeof EmailSendEventV2>;

export const emailEvents = {
  'email-send': EmailSendEventV2,
};

export type EmailEvents = typeof emailEvents;
